import { useState } from 'react';
import styled from '@emotion/styled';

import { Dot } from './Dot';
import { TimeLabel } from './TimeLabel';
import { type StudentScheduleSlot } from '../../model';
import { generateClockOuterDotsAngles, convertScheduleForUI, isCurrentTimeInRange } from '../utils';

const Container = styled.div`
  position: absolute;
  inset: 0;
`;

type Props = {
  currentTime: Date;
  scheduleData: StudentScheduleSlot[];
};

export const ClockOuterRing = ({ currentTime, scheduleData }: Props) => {
  const [timeLabels] = useState(() => convertScheduleForUI(scheduleData, true));
  const [dotAngles] = useState(() => generateClockOuterDotsAngles());

  const renderDots = () =>
    dotAngles.map((angle) => {
      const isBigDot = !!timeLabels[angle];

      return <Dot angle={angle} key={angle} big={isBigDot} />;
    });

  const renderTimeLabel = () =>
    dotAngles.map((angle) => {
      const slot = timeLabels[angle];

      const label = slot?.startTimeLabel;
      const focused = isCurrentTimeInRange(currentTime, slot?.startTime, slot?.endTime);

      if (!label) {
        return;
      }

      return <TimeLabel focused={focused} angle={angle} key={angle} label={label} />;
    });

  return (
    <Container>
      {renderDots()}
      {renderTimeLabel()}
    </Container>
  );
};
